import React from 'react';
import {ArtistCollectioneItem, Box, FrameworkLink} from '@ttx/design-system';
import {ResultOf} from '@graphql-typed-document-node/core';

import {ArtistPerksList} from '../../server/router/collection/types';
import {ArtistDocument} from '../../graphql/generated';

interface PerksListPageProps {
  artistSlug: string;
  perksListMutation: ArtistPerksList;
  artistDetails: ResultOf<typeof ArtistDocument>['artist'];
}

export const PerksListPage: React.FC<PerksListPageProps> = ({
  artistSlug,
  perksListMutation,
  artistDetails,
}: PerksListPageProps) => {
  function formatSlug(text: string) {
    return text.toLowerCase().replace(/\s+/g, '-');
  }

  return (
    <div>
      <Box
        borderColor="grey32"
        borderStyle="solid"
        borderTopWidth="zero"
        borderRightWidth="zero"
        borderLeftWidth="zero"
        borderBottomWidth="zero"
        minHeight="500px"
        height="auto"
        width="10o%"
        marginBottom="twelve"
      >
        {perksListMutation.map((e, i: number) => {
          const perkSlug = formatSlug(e.title);
          return (
            <FrameworkLink
              key={perkSlug}
              href={`/artists/${artistSlug}/perks/${perkSlug}`}
            >
              <ArtistCollectioneItem
                onlyImage
                artistName={artistDetails?.artistName}
                artistImg={artistDetails?.image?.url}
                key={perkSlug}
                imageSrc={e.thumbnail}
                title={e.title}
                description={e.description}
                isLeft={i % 2 === 0}
                isMobile
                buttonText={e.buttonText}
              />
            </FrameworkLink>
          );
        })}
      </Box>
    </div>
  );
};
